import { useDiagnosesByUserV2Query } from '@/entities/diagnosis/hooks/diagnosis.gql.impl';
import { DiagnosesByUserV2Query, SortType } from '@/types/bff/gql-schema';

export interface RecentSymptomItem {
  id: string;
  symptom: string;
}

const parseDiagnosesByUserV2 = (data: DiagnosesByUserV2Query): RecentSymptomItem[] => {
  return data.diagnosesByUserV2.map((diagnosis) => {
    return {
      id: diagnosis.diagnosis.diagnosisForm.id,
      symptom: diagnosis.diagnosis.diagnosisForm.symptom ? diagnosis.diagnosis.diagnosisForm.symptom.slice(0, 150) : '',
    };
  });
};

const useDiagnosesByUserV2 = ({ size = 5 }: { size?: number }) => {
  const { data: recentlyDetailSymptoms = [], isLoading: isRecentlyDetailSymptomsLoading } = useDiagnosesByUserV2Query(
    {
      paginationCriteria: {
        size,
        sort: SortType.Desc,
      },
    },
    {
      select: parseDiagnosesByUserV2,
    }
  );
  return {
    recentlyDetailSymptoms,
    recentlyDetailSymptomsCount: recentlyDetailSymptoms.length,
    isRecentlyDetailSymptomsLoading,
  };
};

export default useDiagnosesByUserV2;
